import { memo } from "react";
import { useDispatch } from "react-redux";

import TrendingDownIcon from "@material-ui/icons/TrendingDown";
import { useChartsContext } from "contexts/ChartContext";
import { updateChartByPath } from "store/features";

import { useChartEntities } from "hooks/charts";

import ToolbarButton from "../../base/ToolbarButton";

const ForecastToggle = () => {
  const dispatch = useDispatch();
  const { id } = useChartsContext();
  const { forecast } = useChartEntities(id);
  const isEnabled = forecast?.enabled ?? false;
  const isActive = forecast?.active ?? false;
  const showButton = forecast?.show;
  const toggle = (active: boolean) => {
    dispatch(
      updateChartByPath({
        id,
        path: `features.forecast.active`,
        value: active
      })
    );
  };
  if (!showButton) return null;
  return (
    <ToolbarButton
      active={isActive}
      icon={<TrendingDownIcon fontSize="large" />}
      overflowLabel="Forecast"
      tooltipText="Toggle Forecast"
      onToggle={toggle}
      disabled={!isEnabled}
      data-testid="forecast-toggle"
    />
  );
};

export default memo(ForecastToggle);
